import React, { ReactElement } from 'react';
import { Area } from '../Footer.styled';
import { TrustpilotReviewsWidget } from '../../TrustpilotReviewsWidget';

interface ReviewsProps {
  inView: boolean;
}

export function Reviews({ inView }: ReviewsProps): ReactElement {
  return (
    <Area name="reviews">
      <TrustpilotReviewsWidget inView={inView} />
    </Area>
  );
}
